import { render } from "./ViewBeneficiaryOpeningBalanceModal.vue?vue&type=template&id=7f1e1b8f&scoped=true"
import script from "./ViewBeneficiaryOpeningBalanceModal.vue?vue&type=script&lang=js"
export * from "./ViewBeneficiaryOpeningBalanceModal.vue?vue&type=script&lang=js"

import "./ViewBeneficiaryOpeningBalanceModal.vue?vue&type=style&index=0&id=7f1e1b8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1e1b8f"]])

export default __exports__